import type { IValidatorParams } from "@edaz/services/baseValidationService";

export interface IsAlphaNumericTextOptions {
  validate?: (entity: any) => boolean;
}

export default function isAlphanumericText(
  value: string | undefined,
  options: IsAlphaNumericTextOptions,
  params?: IValidatorParams
) {
  if (options.validate && !options.validate(params?.entity)) {
    return true;
  }

  const regex = /^([0-9]|[A-Z])*$/;

  if (value) {
    return regex.test(value);
  }

  return true;
}
